<template>
<section class="ui-section">
    <div class="ui-max-width">
        <div class="txt-center">
            <div class="ui-head">
                <h3 v-html="$t('abouthead')"></h3>
            </div>
        </div>
        <div class="ui-ts-text-wrap">
            <p>{{$t('about1') }}</p>
            <p>{{$t('about1a') }}</p>
            <p>{{$t('about2') }}</p>
            <p>{{$t('about3') }}</p>
            <p>{{$t('about4') }}</p>
            <p>{{$t('about5') }}</p>

            <leftee-layout>
                <ui-abutton href="#js-eligible" class="elig-btn abtn abtn--secondary" v-smooth-scroll>{{$t('ats_btn_label')}}</ui-abutton>
            </leftee-layout>

            <!--
            <ul class="ui-ts-ul">
                <li class="list1 ui-ts-li"></li>
                <li class="list2 ui-ts-li"> </li>
                <li class="list3 ui-ts-li"></li>
                <li class="list4 ui-ts-li"></li>
            </ul>
            <ol class="ui-ts-ol">
                <li class="list1 ui-ts-li"></li>
                <li class="list2 ui-ts-li"> </li>
                <li class="list3 ui-ts-li"></li>
                <li class="list4 ui-ts-li"></li>
            </ol>

-->
        </div>
    </div>
</section>
</template>

<script>
import CenteredLayoutVue from '../../components/layout/CenteredLayout.vue'
import UiAnchorButtonVue from '../../components/UiAnchorButton.vue'
//import UiHeadingVue from '../../components/UiHeading.vue'
export default {
 components: {
    "ui-abutton": UiAnchorButtonVue,
    "leftee-layout": CenteredLayoutVue
        //"ui-head": UiHeadingVue
    }
}
</script>


<style scoped>
/*EDIT COLOURS HERE*/
.ui-ts-heading {
    color: #4e5157;
}

.ui-ts-heading span {
    color: #39a8e3;
}

.ui-ts-subheading {
    color: #39a8e3;
}

.ui-ts-subheading {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.005em;
    text-align: left;
    margin-bottom: 8px;
}

.ui-ts-text-wrap {
    margin-left: 0;
}

.ui-ts-ul {
    list-style: disc;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ui-ts-ol {
    list-style: decimal;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ui-ts-li {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 6px;
    padding-left: 8px;
}
</style>
